import { year, toUniversalTime, parse, toString } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { fromDateTime, toString as toString_1 } from "./fable_modules/fable-library-js.4.24.0/DateOnly.js";

export function checkFetchError(x) {
    let matchResult, y_1;
    if (x.tag === 2) {
        if ((x.fields[0].status) === 401) {
            matchResult = 0;
            y_1 = x.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            window.location.reload();
            break;
        }
        case 1: {
            break;
        }
    }
}

export function fromUtcToLocalString(utcString) {
    try {
        return toString(parse(utcString), "dd.MM.yyyy HH:mm");
    }
    catch (matchValue) {
        return utcString;
    }
}

export function fromUtcToLocalDate(utcString) {
    try {
        return toString(parse(utcString), "dd.MM.yyyy");
    }
    catch (matchValue) {
        return utcString;
    }
}

export function toAbbrMonth(x) {
    switch (x) {
        case 1:
            return "Jan";
        case 2:
            return "Feb";
        case 3:
            return "Mar";
        case 4:
            return "Apr";
        case 5:
            return "Mai";
        case 6:
            return "Jun";
        case 7:
            return "Jul";
        case 8:
            return "Aug";
        case 9:
            return "Sep";
        case 10:
            return "Okt";
        case 11:
            return "Nov";
        case 12:
            return "Des";
        default:
            return "N/A";
    }
}

export function toUrlSafeString(s) {
    return encodeURIComponent(s);
}

export function formatDate(dt) {
    return toString(dt, "dd.MM.yyyy");
}

/**
 * Takes a DateTime, converts it to a DateOnly, and formats it to a ISO8601
 * string.
 */
export function formatDateIso8601(dt) {
    return toString_1(fromDateTime(dt), "o", {});
}

/**
 * Takes a DateTime and formats it to a ISO8601 string.
 */
export function formatDateTimeIso8601(dt) {
    return toString(dt, "o", {});
}

export function formatDateForUri(dt) {
    return toString(dt, "yyyy-MM-dd");
}

export function parseDateIso8601(isoString) {
    return parse(isoString);
}

/**
 * NOTE: Manually encode year due to a mega-cursed fable bug that would give off-by-1-year errors (wtf)
 * <summary>
 * Formats a DateTime to "yyyy-MM-dd HH:mmZ"
 * </summary>
 */
export function toUtcString(dt) {
    const utc = toUniversalTime(dt);
    return `${year(utc)}-${toString(utc, "MM-dd HH:mmZ")}`;
}

export const formatIsoString = (arg) => formatDate(parseDateIso8601(arg));

export function isBig(responsive) {
    switch (responsive.tag) {
        case 2:
        case 4:
        case 3:
            return true;
        default:
            return false;
    }
}

export function filteredUserCompanies(userCompanies) {
    const host = window.location.host;
    switch (host) {
        case "digital.torghatten.no":
            return userCompanies.filter((c) => (c !== 4));
        case "ikt-skip-demo.itpartner.no":
            return userCompanies.filter((c_1) => (c_1 !== 5));
        default:
            return userCompanies;
    }
}

export function condDelay(delay, delayTimeMs, f) {
    if (delay) {
        const pr = new Promise(resolve => setTimeout(resolve, delayTimeMs));
        pr.then(() => {
            f();
        });
    }
    else {
        f();
    }
}

//# sourceMappingURL=Utils.js.map
